<template>
    <ValidationProvider
        :name="$t('formularios.tipo_identificacion') + (index > 0 ? (' ' + index) : '')"
        rules="required"
        v-slot="{ errors }"
    >
        <div class="form-group">
            <label>{{ $t('formularios.tipo_identificacion') }}</label>
            <multiselect
                v-model="localType"
                label="label"
                track-by="type"
                class="custom-multiselect"
                :disabled="disabled"
                :class="{ 'is-invalid': errors.length }"
                :id="'tipo-documento-' + index"
                :data-cy="'tipo-documento-' + index"
                :placeholder="$t('formularios.tipo_identificacion')"
                :options="tiposDocumento"
            />
            <span
                v-if="errors[0]"
                class="d-block invalid-feedback text-xs bg-danger white h7 mb-4 p-2 font-weight-bold"
            >
                {{ errors[0] }}
            </span>
        </div>
    </ValidationProvider>
</template>

<script setup>

    import { computed } from 'vue';

    const props = defineProps({
        value: {
            type: String,
            default: ''
        },
        index: {
            type: Number,
            default: 0
        },
        disabled: {
            type: Boolean,
            default: false
        }
    });

    const emit = defineEmits(['input']);

    const tiposDocumento = [
        { type: 'DNI', label: 'DNI' },
        { type: 'NIE', label: 'NIE'},
        { type: 'NIF', label: 'NIF' },
        { type: 'PASAPORTE', label: 'PASAPORTE' },
        { type: 'OTROS', label: 'OTROS' }
    ];

    const localType = computed({
        get() {
            return tiposDocumento.find(opt => opt.type === props.value) || null
        },
        set(option) {
            emit('input', option ? option.type : '')
        }
    });
</script>
